// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', initializeCountdownTimers);


// Initialize all countdown timers on the page
function initializeCountdownTimers() {

  const timerElement = document.getElementById('msdwCountdown');
  CountDownTimer(timerElement);

  // document.querySelectorAll('.msdw-countdown').forEach(timerElement => {
  //   CountDownTimer(timerElement);
  // });
}

// Countdown timer function
function CountDownTimer(timerElement) {
  // Get end date from data attribute
  const endDateString = timerElement.dataset.endDate;
  if (!endDateString) return;

  const end = new Date(endDateString);
  const _second = 1000;
  const _minute = _second * 60;
  const _hour = _minute * 60;
  const _day = _hour * 24;
  let timer;

  function showRemaining() {
    const now = new Date();
    const distance = end - now;

    if (distance < 0) {
      clearInterval(timer);
      timerElement.classList.add('msdw-countdown-expired');
      return;
    }

    const days = Math.floor(distance / _day);
    const hours = Math.floor((distance % _day) / _hour);
    const minutes = Math.floor((distance % _hour) / _minute);
    const seconds = Math.floor((distance % _minute) / _second);

    // CORRECTED: Using textContent for security
    timerElement.querySelector('.msdw-countdown-days span').textContent = days;
    timerElement.querySelector('.msdw-countdown-hours span').textContent = hours;
    timerElement.querySelector('.msdw-countdown-minutes span').textContent = minutes;
    // Uncomment if you need seconds
    // timerElement.querySelector('.msdw-countdown-seconds span').textContent = seconds;
  }

  timer = setInterval(showRemaining, 1000);
  showRemaining(); // Initial call
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', initializeCountdownTimers);
